import styled from '@emotion/styled';
import { LoadingButton, LocalizationProvider, MobileDatePicker } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { Box, Container, Divider, Grid, TextField, Typography, Autocomplete, Button, TableContainer, Table, TableHead, TableCell, TableBody, TableRow, TablePagination } from '@mui/material'
import { Form, FormikProvider, useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Page from '../../components/Page'
import * as Yup from 'yup';
import { Api } from '../../components/api';
import { fDateTo } from '../../utils/formatTime';
import { useNavigate } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import moment from 'moment';
import HasPermission from '../../haspermission/HasPermission';

const listTableHead = [
    {
        title: 'วันที่',
    },
    {
        title: 'ทะเบียนรถ',
    },
    {
        title: 'หมายเลขรถ',
    },
    {
        title: 'สายรถ',
    },
    {
        title: 'รหัสบัตร',
    },
    {
        title: 'ชื่อคนขับ',
    },
    {
        title: '61-69',
    },
    {
        title: '70-79',
    },
    {
        title: '80-99',
    },
    {
        title: '100-120',
    },
    {
        title: '> 120',
    },

]

export default function OverspeedByDate({ account, userId, permissions }) {
    const navigate = useNavigate()
    const [overspeeds, setOverspeeds] = useState([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);


    const schema = Yup.object().shape({
    });
    const selectedTime = new Date();
    const formik = useFormik({
        initialValues: {
            speed: 60,
            date_s: selectedTime,
            date_e: selectedTime,
        },
        validationSchema: schema,
        onSubmit: (values, { setSubmitting }) => {
            const { date_s, date_e, speed } = values
            const { c_coname } = account;

            Api.get('/Tracking/SpeedLevelByEvents', {
                params: {
                    // cocode: cocode,
                    cname: c_coname,
                    dateStart: fDateTo(date_s, 'yyyy-MM-dd'),
                    dateEnd: fDateTo(date_e, 'yyyy-MM-dd'),
                    speed: speed
                }
            }).then((res) => {
                const { data } = res
                setOverspeeds(data.sort((a, b) => a.date.localeCompare(b.date)))
                setPage(0)
                setSubmitting()
            }).catch((e) => {
                setOverspeeds([])
                setPage(0)
                setSubmitting()

            })
        }
    })


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, setFieldValue } = formik;
    return (
        <Page>
            <Container>
                <Box flexGrow={1} padding={1}>
                    <Typography variant="h4">Event : Overspeed by date</Typography>
                </Box>
            </Container>
            <Divider />
            <MainStyle>
                <Container sx={{ padding: 3 }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <FormikProvider value={formik}>
                            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                                <Grid container spacing={3}>
                                    <Grid item xs={6} sm={6}>
                                        <MobileDatePicker
                                            ampm={false}
                                            disableFuture={true}
                                            label="วันเวลาเริ่ม"
                                            allowKeyboardControl={false}
                                            value={values.date_s}
                                            inputFormat="dd/MM/yyyy"
                                            format="dd/MM/yyyy"
                                            onChange={(val) => {
                                                setFieldValue('date_s', val);
                                            }}
                                            renderInput={(params) => <TextField
                                                size="small"
                                                {...params}
                                                {...getFieldProps('date_r')}
                                                fullWidth
                                                placeholder="DD/MM/YYYY"
                                                autoComplete="off"
                                                error={Boolean(touched.date_s && errors.date_s)}
                                                helperText={touched.date_s && errors.date_s} />}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={6}>
                                        <MobileDatePicker
                                            minDate={new Date(values.date_s)}
                                            maxDate={new Date(values.date_s).setDate(new Date(values.date_s).getDate() + 31)}
                                            ampm={false}
                                            disableFuture={true}
                                            label="ถึงวันเวลา"
                                            allowKeyboardControl={false}
                                            value={values.date_e}
                                            inputFormat="dd/MM/yyyy"
                                            format="dd/MM/yyyy"
                                            onChange={(val) => {
                                                setFieldValue('date_e', val);
                                            }}
                                            renderInput={(params) => <TextField
                                                size="small"
                                                {...params}
                                                {...getFieldProps('date_e')}
                                                fullWidth
                                                placeholder="DD/MM/YYYY"
                                                autoComplete="off"
                                                error={Boolean(touched.date_e && errors.date_e)}
                                                helperText={touched.date_e && errors.date_e} />}
                                        />
                                    </Grid>
                                    <Grid item xs={6} justifyContent="flex-end" justifyItems="center">
                                        <Box
                                            display="flex"
                                            justifyContent="flex-end"
                                            alignItems="center"
                                        >
                                            <LoadingButton
                                                style={{ height: 40, width: 80 }}
                                                // fullWidth={true}
                                                size="small"
                                                type="submit"
                                                variant="contained"
                                                loading={isSubmitting}

                                            >
                                                ค้นหา
                                            </LoadingButton>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box
                                            display="flex"
                                            justifyContent="flex-start"
                                            alignItems="center"
                                        >
                                            <Button
                                                style={{ height: 40, width: 80 }}
                                                // fullWidth={true}
                                                size="small"
                                                type="submit"
                                                variant="contained"
                                                color="info"
                                                onClick={() => {
                                                    navigate('/report/event')
                                                }}

                                            >
                                                กลับ
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Form>
                        </FormikProvider>
                    </LocalizationProvider>
                </Container>
                {
                    overspeeds.length > 0 && (
                        <Container sx={{ padding: 3 }}>
                            <Box sx={{ padding: 1 }}
                                display="flex"
                                justifyContent="flex-end"
                            >
                                <HasPermission permissions={permissions} scope={["download"]}>
                                    <Button as={CSVLink} filename={`${fDateTo(values.date_s, 'dd_MM_yyyy_HH:mm')}-${fDateTo(values.date_e, 'dd_MM_yyyy_HH:mm')}.csv`} data={
                                        overspeeds.map((value, index) => {
                                            const {
                                                vehicle_id, date, car_id, group_id, driver_id, name, SV61_69, SV70_79, SV80_99, SV100_120, SV120
                                            } = value;
                                            return {
                                                "วันที่": `=""${fDateTo(new Date(moment(date, "DD-MM-YYYY")), 'dd/MM/yyyy')}""`,
                                                "ทะเบียนรถ": `=""${vehicle_id}""`,
                                                "หมายเลขรถ": `=""${car_id}""`,
                                                "สายรถ": `=""${group_id}""`,
                                                "รหัสบัตร": `=""${driver_id}""`,
                                                "ชื่อคนขับ": `=""${name}""`,
                                                "61-69": `=""${SV61_69}""`,
                                                "70-79": `=""${SV70_79}""`,
                                                "80-99": `=""${SV80_99}""`,
                                                "100-120": `=""${SV100_120}""`,
                                                "> 120": `=""${SV120}""`
                                            }
                                        }
                                        )
                                    } variant="contained" style={{
                                        textDecorationLine: 'none',
                                    }} >
                                        Download
                                    </Button>
                                </HasPermission>
                            </Box>
                            <TableContainer>
                                <Table>
                                    <TableHead >
                                        <TableRow>
                                            {
                                                listTableHead.map((item, index) => {
                                                    return <TableCell style={{ textTransform: 'capitalize', whiteSpace: "nowrap" }} key={index} >{item.title}</TableCell>
                                                })
                                            }
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            overspeeds.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((value, index) => {
                                                const {
                                                    vehicle_id, date, car_id, group_id, driver_id, name, SV61_69, SV70_79, SV80_99, SV100_120, SV120
                                                } = value;
                                                return (
                                                    <TableRow
                                                        hover
                                                        key={index}
                                                        tabIndex={-1}
                                                    >
                                                        <TableCell style={{ whiteSpace: "nowrap" }}>{fDateTo(new Date(moment(date, "DD-MM-YYYY")), 'dd/MM/yyyy')}</TableCell>
                                                        <TableCell style={{ whiteSpace: "nowrap" }}>{vehicle_id}</TableCell>
                                                        <TableCell style={{ whiteSpace: "nowrap" }}>{car_id}</TableCell>
                                                        <TableCell style={{ whiteSpace: "nowrap" }}>{group_id}</TableCell>
                                                        <TableCell style={{ whiteSpace: "nowrap" }}>{driver_id}</TableCell>
                                                        <TableCell style={{ whiteSpace: "nowrap" }}>{name}</TableCell>
                                                        <TableCell style={{ whiteSpace: "nowrap" }}>{SV61_69}</TableCell>
                                                        <TableCell style={{ whiteSpace: "nowrap" }}>{SV70_79}</TableCell>
                                                        <TableCell style={{ whiteSpace: "nowrap" }}>{SV80_99}</TableCell>
                                                        <TableCell style={{ whiteSpace: "nowrap" }}>{SV100_120}</TableCell>
                                                        <TableCell style={{ whiteSpace: "nowrap" }}>{SV120}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[
                                    { value: 10, label: '10' },
                                    { value: 20, label: '20' },
                                    { value: 30, label: '30' },
                                    { value: 50, label: '50' },
                                    // { value: 100, label: 100 },
                                    // { value: listLog.length, label: 'All' }
                                ]}
                                component="div"
                                count={overspeeds.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </Container>
                    )}
            </MainStyle>
        </Page>
    )
}

const MainStyle = styled(Box)(({ theme }) => ({
    margin: 'auto',
    overflow: 'auto',
    paddingTop: 10,
    paddingBottom: 60,
    paddingLeft: 10,
    paddingRight: 10
}));